import React from 'react';

import StyledTooltip from '../../../../../../common/widgets/StyledToolTip';
import InfoIcon from '../../../../../../images/icons/green-info-icon.svg?react';
import { Amount } from '../../../shared/amount-view/Amount/Amount';

export const CreateInvoiceHeader = ({ editPDFMode, selectedPayee, elligibleAmountForPageInfo, eventsCount }) => {
  return (
    <div className="panel-header">
      <div className="ful-screen-modal-name">{editPDFMode ? 'Edit Invoice' : 'Create Invoice'}</div>
      <div className="create-invoice-info">
        {`${eventsCount} Event IDs • `}
        <Amount coinsAmount={elligibleAmountForPageInfo} showDollarSign={true} />
        Eligible
      </div>
      <StyledTooltip
        className="tooltip-bank-info"
        overlay={
          <div className="info-value">
            {selectedPayee?.name} <br />
            {selectedPayee?.bankName} <br />
            {`Routing: ${selectedPayee?.bankRoutingNumber}`}
            <br />
            {`Account: ${selectedPayee?.bankAccountNumber}`}
            <br />
            {`SWIFT: ${selectedPayee?.bankSwiftCode}`}
          </div>
        }
        placement="bottom"
      >
        <div className="create-invoice-bank-info">
          <InfoIcon />
          Banking Information
        </div>
      </StyledTooltip>
    </div>
  );
};
